import React from 'react';
import { FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ClearableInput = ({
  value,
  onChange,
  onEnter,
  onClear,
  placeholder = 'Search...',
  style = {},
  inputProps = {}
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter();
    }
  };

  const handleClear = () => {
    onChange({ target: { value: '' } });
    if (onClear) onClear();
  };

  return (
    <div style={{ position: 'relative', maxWidth: '300px', ...style }}>
      <FormControl
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        style={{ paddingRight: '2rem' }}
        {...inputProps}
      />
      {value && (
        <FontAwesomeIcon
          icon={faTimes}
          onClick={handleClear}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: '#aaa',
            fontSize: '0.85rem',
            pointerEvents: 'auto'
          }}
        />
      )}
    </div>
  );
};

export default ClearableInput;
